export default "__VITE_ASSET__DeIOdhoI__"